import { useState } from "react";

/**
 * 필터 상태 관리 훅
 * @param {Object} initialFilter - 초기 필터 객체
 * @returns {Object} { filter, tempFilter, setFilter, applyFilter, resetFilter, updateFilter }
 */
export function useFilters(initialFilter) {
  const [filter, setFilter] = useState(initialFilter);
  const [tempFilter, setTempFilter] = useState(initialFilter);

  /**
   * 필터 적용 (임시 필터를 실제 필터에 적용하고 페이지를 1로 리셋)
   */
  const applyFilter = () => {
    setFilter({ ...tempFilter, page: 1 });
  };

  /**
   * 필터 초기화
   */
  const resetFilter = () => {
    setTempFilter(initialFilter);
    setFilter(initialFilter);
  };

  /**
   * 필터 필드 업데이트 (임시 필터만 업데이트, API 호출 안 함)
   * @param {string} name - 필드명
   * @param {any} value - 값
   */
  const updateFilter = (name, value) => {
    setTempFilter((prev) => ({ ...prev, [name]: value }));
  };

  /**
   * 페이지 변경 (filter를 직접 업데이트하여 API 호출 트리거)
   * @param {number} page - 변경할 페이지 번호
   */
  const setPage = (page) => {
    setFilter((prev) => ({ ...prev, page }));
    setTempFilter((prev) => ({ ...prev, page }));
  };

  return {
    filter,
    tempFilter,
    setFilter,
    setPage,
    applyFilter,
    resetFilter,
    updateFilter,
  };
}
